export function getSubject(type) {
	let subject, previewText;

	if (type === 'welcomeEmail' || type === 'confirmEmail') {
		subject = 'Veuillez confirmer votre adresse e-mail';
		previewText = 'Action requise ! Confirmez votre adresse e-mail';
	}
	if (type === 'bookingRequest') {
		subject = 'Vous avez une nouvelle réservation';
		previewText = 'Bonne nouvelle ! Vous avez une nouvelle réservation';
	}
	if (type === 'bookingRequestGuest') {
		subject = 'Votre demande de réservation a été envoyée à votre hôte';
		previewText = 'Bonne nouvelle ! Votre réservation a été partagée avec l\'hôte';
	}
	if (type === 'bookingConfirmedToHost') {
		subject = 'Vous avez confirmé une réservation';
		previewText = 'Détails de la réservation confirmée';
	}
	if (type === 'bookingConfirmedToGuest') {
		subject = 'Votre réservation a été confirmée par votre hôte';
		previewText = 'Préparez vos bagages, votre voyage approche.';
	}
	if (type === 'bookingDeclinedToGuest') {
		subject = 'Votre demande de réservation a été refusée par votre hôte';
		previewText = 'Nous avons le regret de vous informer que votre demande de réservation a été refusée';
	}
	if (type === 'bookingExpiredGuest') {
		subject = 'Votre demande de réservation a expiré';
		previewText = 'Nous avons le regret de vous informer que votre demande de réservation a expiré';
	}
	if (type === 'bookingExpiredHost') {
		subject = 'Réservation expirée !';
		previewText = 'Nous avons le regret de vous informer que votre réservation a expiré';
	}
	if (type === 'cancelledByHost') {
		subject = 'Votre réservation a été annulée par l\'hôte';
		previewText = 'Nous avons le regret de vous informer que votre réservation a été annulée';
	}
	if (type === 'cancelledByGuest') {
		subject = 'Votre réservation a été annulée par le voyageur';
		previewText = 'Nous avons le regret de vous informer que votre réservation a été annulée';
	}
	if (type === 'completedGuest') {
		subject = 'Veuillez laisser un avis sur votre séjour';
		previewText = 'Bonjour ! Nous serions ravis d\'avoir votre avis sur votre expérience de séjour';
	}
	if (type === 'completedHost') {
		subject = 'Veuillez laisser un avis sur votre voyageur';
		previewText = 'Bonjour ! Nous serions ravis d\'avoir votre avis sur votre expérience de réservation';
	}
	if (type === 'forgotPasswordLink') {
		subject = 'Réinitialisez votre mot de passe';
		previewText = 'Action requise ! Réinitialisez votre mot de passe en utilisant le lien fourni';
	}
	if (type === 'message') {
		subject = 'Vous avez reçu un nouveau message';
		previewText = 'Quelqu\'un vous a envoyé un nouveau message !';
	}

	if (type === 'inquiry') {
		subject = 'Vous avez reçu une nouvelle demande';
		previewText = 'Quelqu\'un vous a envoyé une demande via le formulaire de contact !';
	}

	if (type === 'documentVerification') {
		subject = 'Statut de vérification des documents';
		previewText = 'Statut de vérification des documents';
	}
	if (type === 'contact') {
		subject = 'Vous avez reçu une notification du support client';
		previewText = 'Vous avez reçu une notification du support client';
	}
	if (type === 'reportUser') {
		subject = 'Vous avez reçu une notification de signalement d\'utilisateur';
		previewText = 'Vous avez reçu une notification concernant un signalement d\'utilisateur';
	}
	if (type === 'bookingPreApproval') {
		subject = 'L\'hôte a pré-approuvé votre demande';
		previewText = 'Bonjour ! Votre demande de pré-approbation a été acceptée par l\'hôte';
	}

	if (type === 'banStatusServiceStatusBanned') {
		subject = 'Votre compte a été désactivé';
		previewText = 'Nous avons le regret de vous informer que votre compte a été désactivé';
	}
	if (type === 'banStatusServiceStatusUnBanned') {
		subject = 'Votre compte a été réactivé';
		previewText = 'Bonne nouvelle ! Nous avons le plaisir de vous informer que votre compte a été réactivé';
	}
	if (type === 'contactSupport') {
		subject = 'Vous avez reçu une notification du support client';
		previewText = 'Vous avez reçu une notification du support client';
	}
	if (type === 'userFeedback') {
		subject = 'Vous avez reçu un retour client';
		previewText = 'Vous avez reçu un retour client';
	}
	if (type === 'listPublishRequest') {
		subject = 'Vous avez une nouvelle annonce à approuver';
		previewText = 'Vous avez une nouvelle annonce à approuver';
	}
	if (type == 'adminListApprove') {
		subject = 'Votre annonce a été approuvée';
		previewText = 'Bonne nouvelle ! Votre annonce a été approuvée';
	}
	if (type == 'adminListReject') {
		subject = 'Votre annonce a été refusée';
		previewText = 'Nous avons le regret de vous informer que votre annonce a été refusée';
	}
	if (type === 'paymentCompletedGuest') {
		subject = 'Paiement confirmé - Votre réservation est prête !';
		previewText = 'Bonne nouvelle ! Votre paiement a été traité et votre réservation est confirmée.';
	}
	if (type === 'paymentCompletedHost') {
		subject = 'Paiement reçu - Le voyageur a confirmé sa réservation';
		previewText = 'Bonne nouvelle ! Votre voyageur a effectué son paiement et la réservation est confirmée.';
	}
	return {
		subject,
		previewText
	};
}